import { deleteData, getData, postData, putData } from "../Config/AxiosConfig"


export const addUsers = async (body) => {
    return await postData('user', body)
}

export const updateUser = async (id, body) => {
    return await putData(`user/${id}`, body)
}

export const deleteUser = async (id) => {
    return await deleteData(`user/${id}`)
}

export const getUsers = async (id) => {
    return await getData(`user/${id}`)
}

export const updatePassword = async (body) => {
    return await putData(`update-password`, body)
}



export const loginUser = async (body) => {
    return await postData("login", body)
} 